module.exports = __webpack_public_path__ + "static/pexels-3-90e1351c6244880b6d530608b39c9787.jpg";